import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Input,
  Label,
  Form,
} from "reactstrap";
import { toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import UploadFile from "../UploadFile";
import Config from "../../utils/config";
import CustomButton from "../CustomButton";
import CartTitle from "../CartTitle";
import InputText from "../InputText";
import Loader from "../Loader";
import { nameValidation } from "../../utils/helperFunction";
import get from "lodash/get";

const _ = { get };

const initialState = {
  addressLine1: "",
  addressLine2: "",
  addressLine3: "",
  altPhone: "",
  businessHours: "",
  city: "",
  city_id: "",
  country: "",
  countryCode: "",
  country_id: "",
  branchPrincipalName: "",
  branchName: "",
  emailId: "",
  googlePlaceId: "",
  landmark: "",
  longitude: 0,
  latitude: 0,
  phone: "",
  pincode: "",
  dealer_id: "",
  state: "",
  stateCode: "",
  state_id: "",
  storeManagerName: "",
  websiteUrl: "",
  weeklyOff: "",
  locality: null,
  dealerName: "",
  dealerPrincipalName: "",
  dealerId: "",
  dealerWebsiteUrl: "",
  tab: "",
  id: "",
  branchId: "",
  facebookUrl: "",
  branchCode: "",
  instagramUrl: "",
  branchDescription: "",
  image: {
    preview: null,
    Image: null,
  },
};

function appliedBranchCreate(props) {
  let { elements } = props;

  const [state, setState] = useState(initialState);

  useEffect(() => {
    if (props.page !== "apply-for-branch-create") {
      if (props.userProfile.name !== "") {
        if (props.branchData !== null) {
          handleUpdateForm();
        } else {
          props.handleFetchSingleBranch(
            props.userProfile.additionalInfo.branchId
          );
        }
      }
    } else {
      if (props.dealerProfile !== null) {
        state.storeManagerName = props.dealerProfile.storeManagerName;
        state.dealerName = props.dealerProfile.dealerName;
        state.dealerId = props.dealerProfile.dealerId;
        state.dealerPrincipalName = props.dealerProfile.dealerPrincipalName;
        state.dealer_id = props.dealerProfile._id;
        state.latitude = props.dealerProfile.latitude;
        state.branchCode = props.dealerProfile.branchCode;
        state.longitude = props.dealerProfile.longitude;
        state.addressLine1 = props.dealerProfile.addressLine1;
        state.branchPrincipalName = props.dealerProfile.branchName;
        state.websiteUrl = props.dealerProfile.websiteUrl;
        state.pincode = props.dealerProfile.pincode;
        state.phone = props.dealerProfile.phone;
        state.emailId = props.dealerProfile.emailId;
        state.weeklyOff = props.dealerProfile.weeklyOff;
        state.facebookUrl = props.dealerProfile.facebookUrl;
        state.businessHours = props.dealerProfile.businessHours;
        state.instagramUrl = props.dealerProfile.instagramUrl;
        state.branchDescription = props.dealerProfile.branchDescription;
        state.addressLine2 = props.dealerProfile.addressLine2;
        state.addressLine3 = props.dealerProfile.addressLine3;
        state.landmark = props.dealerProfile.landmark;
        state.altPhone = props.dealerProfile.altPhone;
        state.country = props.dealerProfile.country;
        state.state = props.dealerProfile.state;
        state.city = props.dealerProfile.city;
        state.locality = props.dealerProfile.locality;
        setState({ ...state });
      }
    }
  }, [props.userProfile, props.dealerProfile, props.branchData]);

  const handleChange = (e, id) => {
    if (id === "phone") {
      let value = e.target.value;
      if (value.length <= 14) {
        state.phone = e.target.value;
        setState({ ...state });
      }
      if (id === "email") {
        let value = e.target.value;
        if (value.match(nameValidation)) {
          state.emailId = e.target.value;
          setState({ ...state });
        }
      }
    } else {
      state[e.target.name] = e.target.value;
      console.log(e.target.value);
      setState({ ...state });
    }
  };

  const handleCoordinateChange = (e) => {
    state[e.target.name] = e.target.value;
    setState({ ...state });
  };

  const handleCountryChange = (e) => {
    let parsedValue = JSON.parse(e.target.value);
    if (e.target.value !== "Select Country") {
      state.country = parsedValue.country;
      state.countryCode = parsedValue.locality.country;
      state.locality = parsedValue.locality;
      state.state = "";
      state.city = "";
    }
    setState({ ...state });
    props.handleFetchBranchState(state.countryCode.toUpperCase());
  };

  // const handleStateChange = (e) => {
  //   let parsedValue = JSON.parse(e.target.value);
  //   if (e.target.value !== "Select State") {
  //     state.state = parsedValue.name;
  //     state.stateCode = parsedValue.stateCode;
  //     state.city = "";
  //   }
  //   setState({ ...state });
  //   let data = {
  //     countryCode: state.countryCode.toUpperCase(),
  //     state: state.stateCode,
  //   };
  //   props.handleFetchBranchCity(data);
  // };

  // const handleCityChange = (e) => {
  //   let parsedValue = JSON.parse(e.target.value);
  //   if (e.target.value !== "Select City") {
  //     state.city = parsedValue.name;
  //   }
  //   setState({ ...state });
  // };

  const handleImageChange = (e) => {
    e.preventDefault();
    var fileTypes = ["jpg", "jpeg", "png"];
    if (e.target.files[0]) {
      var extension = e.target.files[0].name
          .split(".")
          .pop()
          .toLowerCase(), //file extension from input file
        isSuccess = fileTypes.indexOf(extension) > -1;

      if (isSuccess) {
        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
          saveImage(reader.result, file);
        };
        reader.readAsDataURL(file);
      } else {
        toast.error(
          _.get(
            elements,
            "branchCreationElement.imageValidationElement",
            "only '.jpg' , '.jpeg' , '.png' file types are accepted"
          )
        );
      }
    } else {
    }

    e.target.value = "";
  };
  const deleteImage = () => {
    state.image.Image = null;
    state.image.preview = null;
    setState({ ...state });
  };

  const saveImage = (preview, Image) => {
    const file = {
      preview,
      Image,
    };
    state.image = file;
    setState({ ...state });
  };

  const handleUpdateForm = () => {
    let { branchData } = props;
    state.addressLine1 = branchData.addressLine1;
    state.addressLine2 = branchData.addressLine2;
    state.addressLine3 = branchData.addressLine3;
    state.altPhone = branchData.altPhone;
    state.businessHours = branchData.businessHours;
    state.city = branchData.city;
    state.country = branchData.country;
    state.branchName = branchData.branchName;
    state.branchPrincipalName = branchData.branchPrincipalName;
    state.branchStatus = branchData.branchStatus;
    state.branchType = branchData.branchType;
    state.emailId = branchData.emailId;
    state.landmark = branchData.landmark;
    state.latitude = branchData.latitude;
    state.locality = branchData.locality;
    state.longitude = branchData.longitude;
    state.phone = branchData.phone;
    state.pincode = branchData.pincode;
    state.state = branchData.state;
    state.storeManagerName = branchData.storeManagerName;
    state.branchDescription = branchData.branchDescription;
    state.weeklyOff = branchData.weeklyOff;
    state.websiteUrl = branchData.websiteUrl;
    state.dealer_id = branchData.dealer !== null ? branchData.dealer._id : "";
    state.branchId = branchData._id;
    state.facebookUrl = branchData.facebookUrl;
    state.dealerName =
      branchData.dealer !== null ? branchData.dealer.dealerName : "";
    state.dealerPrincipalName =
      branchData.dealer !== null ? branchData.dealer.dealerPrincipalName : "";
    state.dealerId =
      branchData.dealer !== null ? branchData.dealer.dealerId : "";
    state.branchCode = branchData.branchCode;
    state.instagramUrl = branchData.instagramUrl;
    state.image.preview = `${Config.imageBaseUrl}${branchData.primary_image}`;
    state.image.Image = `${Config.imageBaseUrl}${branchData.primary_image}`;
    setState({ ...state });
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();

    // let payload = {
    //   addressLine1: state.addressLine1,
    //   addressLine2: state.addressLine2,
    //   addressLine3: state.addressLine3,
    //   altPhone: state.altPhone,
    //   businessHours: state.businessHours,
    //   city: state.city,
    //   country: state.country,
    //   branchName: state.branchName,
    //   branchPrincipalName: state.branchPrincipalName,
    //   emailId: state.emailId,
    //   landmark: state.landmark,
    //   latitude: state.latitude,
    //   locality: JSON.stringify(state.locality),
    //   longitude: state.longitude,
    //   phone: state.phone,
    //   branchDescription: state.description,
    //   pincode: state.pincode,
    //   state: state.state,
    //   storeManagerName: state.storeManagerName,
    //   weeklyOff: state.weeklyOff,
    //   websiteUrl: state.websiteUrl,
    //   dealer: state.dealer_id,
    //   dealerId: state.dealerId,
    //   id: state.id,
    //   tab: state.tab,
    //   branchId: state.branchId,
    //   facebookUrl: state.facebookUrl,
    //   branchCode: state.branchCode,
    //   instagramUrl: state.instagramUrl,
    // };

    let formData = new FormData();
    formData.append("addressLine1", state.addressLine1);
    formData.append("addressLine2", state.addressLine2);
    formData.append("addressLine3", state.addressLine3);
    formData.append("altPhone", state.altPhone);
    formData.append("businessHours", state.businessHours);
    formData.append("city", state.city);
    formData.append("country", state.country);
    formData.append("branchName", state.branchName);
    formData.append("branchPrincipalName", state.branchPrincipalName);
    formData.append("emailId", state.emailId);
    formData.append("landmark", state.landmark);
    formData.append("latitude", state.latitude);
    formData.append("locality", JSON.stringify(state.locality));
    formData.append("longitude", state.longitude);
    formData.append("phone", state.phone);
    formData.append("pincode", state.pincode);
    formData.append("state", state.state);
    formData.append("storeManagerName", state.storeManagerName);
    formData.append("weeklyOff", state.weeklyOff);
    formData.append("websiteUrl", state.websiteUrl);
    formData.append("dealer", props.userProfile.additionalInfo.dealerId);
    formData.append("id", state.id);
    formData.append("branchId", state.branchId);
    formData.append("facebookUrl", state.facebookUrl);
    formData.append("branchCode", state.branchCode);
    formData.append("instagramUrl", state.instagramUrl);
    formData.append("image", state.image.Image);
    formData.append("branchDescription", state.branchDescription);

    let data = {
      formData: formData,
      tab: state.tab,
      id: state.dealer_id,
      branchId: props.userProfile.additionalInfo.branchId,
    };

    if (props.userProfile) {
      if (state.phone.length >= 8 && state.phone.length <= 15) {
        if (state.country !== "") {
          if (state.state !== "") {
            if (state.city !== "") {
              if (props.page === "apply-for-branch-create") {
                props.handleCreateAppliedBranch(data);
              } else {
                props.handleUpdateAppliedBranch(data);
              }
            } else {
              toast.error(
                _.get(
                  elements,
                  "branchCreationElement.cityValidationElement",
                  "City cannot be empty"
                )
              );
            }
          } else {
            toast.error(
              _.get(
                elements,
                "branchCreationElement.stateValidationElement",
                "State cannot be empty"
              )
            );
          }
        } else {
          toast.error(
            _.get(
              elements,
              "branchCreationElement.countryValidationElement",
              "Country cannot be empty"
            )
          );
        }
      } else {
        toast.error(
          _.get(
            elements,
            "branchCreationElement.phoneValidationElement",
            "phone Length should be more than 7 and less than 16"
          )
        );
      }
    }
  };

  return (
    <React.Fragment>
      {props.page === "apply-for-branch-create" ? (
        <div>
          {props.createAppliedBranchStatus !== false ? <Loader /> : null}
        </div>
      ) : (
        <div>
          {props.updateAppliedBranchStatus !== false ? <Loader /> : null}
          {props.branchSingleDataStatus !== false ? <Loader /> : null}
        </div>
      )}

      <div className="hideSearch">
        <Row>
          <Col sm={12}>
            <CartTitle
              iconClass={"hideexcel"}
              title={
                props.page === "apply-for-branch-create"
                  ? _.get(
                      elements,
                      "branchCreationElement.createHeadingElement",
                      "Branch Creation"
                    )
                  : _.get(
                      elements,
                      "branchCreationElement.updateHeadingElement",
                      "Branch Update"
                    )
              }
              Name={"Search"}
              customClass={"hidebtn"}
              innerTextClass={"hidetext"}
            />
          </Col>
        </Row>

        <Form onSubmit={handleSubmitForm}>
          <Card className="mb-3">
            <CardBody>
              <Row>
                <Col md="12">
                  <h3 className="title-bar secondary-title f-weight-bold mb-3 pb-2 themeColor">
                    <span>
                      {_.get(
                        elements,
                        "branchCreationElement.subHeadingMainInformationElement",
                        "MAIN INFORMATION"
                      )}
                    </span>
                  </h3>
                </Col>
                <Col xl={12}>
                  <Row>
                    <Col xl={4} lg={4} md={12} sm={12} className="mb-2 pt-4">
                      <UploadFile
                        id="image2"
                        image={state.image}
                        handleImageChange={handleImageChange}
                        deleteImage={deleteImage}
                      />
                    </Col>
                    <Col xl={8} lg={8} md={12} sm={12}>
                      <Row>
                        <Col xl={6} lg={6} md={6} sm={6}>
                          <InputText
                            labelName={_.get(
                              elements,
                              "branchCreationElement.branchPrincipalNameLabel",
                              "Branch Name*"
                            )}
                            inputType={"text"}
                            inputName={"branchPrincipalName"}
                            InputClass={"inputText"}
                            customValue={state.branchPrincipalName}
                            inputPlaceholder={_.get(
                              elements,
                              "branchCreationElement.branchPrincipalNamePlaceholder",
                              "Branch Name"
                            )}
                            customOnChange={(e) => handleChange(e)}
                            customRequired={true}
                          />
                        </Col>

                        {/* <Col xl={8} lg={8} md={12} sm={12}>
                      <Row> */}
                        <Col xl={6} lg={6} md={6} sm={6}>
                          <InputText
                            labelName={_.get(
                              elements,
                              "branchCreationElement.emailLabel",
                              "Email ID / Store ID*"
                            )}
                            inputType={"text"}
                            inputName={"emailId"}
                            InputClass={"inputText"}
                            customValue={state.emailId}
                            inputPlaceholder={_.get(
                              elements,
                              "branchCreationElement.emailPlaceholder",
                              "Email ID / Store ID"
                            )}
                            customOnChange={(e) => handleChange(e, "email")}
                            customRequired={true}
                          />
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={6}>
                          <InputText
                            labelName={_.get(
                              elements,
                              "branchCreationElement.phoneNumberLabel",
                              "Phone Number*"
                            )}
                            inputType={"tel"}
                            inputName={"phone"}
                            InputClass={"inputText"}
                            inputPlaceholder={_.get(
                              elements,
                              "branchCreationElement.phoneNumberPlaceholder",
                              "Phone Number"
                            )}
                            customValue={state.phone}
                            customOnChange={(e) => handleChange(e, "phone")}
                            customRequired={true}
                          />
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={6}>
                          <InputText
                            labelName={_.get(
                              elements,
                              "branchCreationElement.alternatePhoneNumberLabel",
                              "Alternate Phone Number"
                            )}
                            inputType={"number"}
                            inputName={"altPhone"}
                            InputClass={"inputText"}
                            customValue={state.altPhone}
                            inputPlaceholder={_.get(
                              elements,
                              "branchCreationElement.alternatePhoneNumberPlaceholder",
                              "Alternate Phone Number"
                            )}
                            customOnChange={(e) => handleChange(e)}
                          />
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={6}>
                          <Label className="inputLabel">
                            {_.get(
                              elements,
                              "branchCreationElement.countryLabel",
                              "Country*"
                            )}
                          </Label>
                          <FormGroup className=" confirmRiderSelect select_options">
                            <Input
                              type="select"
                              name="City"
                              className=" w-100 customeSelectBtn"
                              onChange={handleCountryChange}
                            >
                              <option selected="true" disabled="disabled">
                                {state.country !== ""
                                  ? state.country
                                  : _.get(
                                      elements,
                                      "branchCreationElement.selectCountryLabel",
                                      "Select Country"
                                    )}
                              </option> 
                              {props.countriesBranch.map((item) => (
                                <option value={JSON.stringify(item)}>
                                  {item.country}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>

                        <Col xl={6} lg={6} md={6} sm={6}>
                          {/* <Label className="inputLabel">
                            {_.get(
                              elements,
                              "branchCreationElement.stateLabel",
                              "State*"
                            )}
                          </Label> */}
                          <FormGroup className=" confirmRiderSelect select_options">
                            <InputText
                              labelName={_.get(
                                elements,
                                "branchCreationElement.stateLabel",
                                "State*"
                              )}
                              inputType={"text"}
                              inputName={"state"}
                              InputClass={"inputText"}
                              customValue={state.state}
                              inputPlaceholder={_.get(
                                elements,
                                "branchCreationElement.stateLabel",
                                "State"
                              )}
                              customOnChange={(e) => handleChange(e)}
                            />

                            {/* <Input
                              type="select"
                              name="branchType"
                              className=" w-100 customeSelectBtn"
                              onChange={handleStateChange}
                            >
                              <option selected="true" disabled="disabled">
                                {" "}
                                {state.state !== ""
                                  ? state.state
                                  : "Select State"}
                              </option>
                              {props.statesBranch
                                .sort((a, b) =>
                                  a.name > b.name ? 1 : b.name > a.name ? -1 : 0
                                )
                                .map((item) => (
                                  <option value={JSON.stringify(item)}>
                                    {item.name}
                                  </option>
                                ))}
                            </Input> */}
                          </FormGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>

                <Col xl={4} lg={4} md={6} sm={6}>
                  {/* <Label className="inputLabel">
                    {_.get(
                      elements,
                      "branchCreationElement.cityLabel",
                      "City*"
                    )}
                  </Label> */}
                  <FormGroup className="confirmRiderSelect select_options">
                    <InputText
                      labelName={_.get(
                        elements,
                        "branchCreationElement.cityLabel",
                        "City*"
                      )}
                      inputType={"text"}
                      inputName={"city"}
                      InputClass={"inputText"}
                      customValue={state.city}
                      inputPlaceholder={_.get(
                        elements,
                        "branchCreationElement.cityLabel",
                        "City"
                      )}
                      customOnChange={(e) => handleChange(e)}
                    />
                    {/* <Input
                      type="select"
                      name="branchType"
                      className=" w-100 customeSelectBtn"
                      onChange={handleCityChange}
                    >
                      <option selected="true" disabled="disabled">
                        {" "}
                        {state.city !== "" ? state.city : "Select City"}
                      </option>
                      {props.citiesBranch
                        .sort((a, b) =>
                          a.name > b.name ? 1 : b.name > a.name ? -1 : 0
                        )
                        .map((item) => (
                          <option value={JSON.stringify(item)}>
                            {item.name}
                          </option>
                        ))}
                    </Input> */}
                  </FormGroup>
                </Col>

                <Col xl={4} lg={4} md={6} sm={6}>
                  <InputText
                    labelName={_.get(
                      elements,
                      "branchCreationElement.landmarkLabel",
                      "Landmark"
                    )}
                    inputType={"text"}
                    inputName={"landmark"}
                    InputClass={"inputText"}
                    customValue={state.landmark}
                    inputPlaceholder={_.get(
                      elements,
                      "branchCreationElement.landmarkPlaceholder",
                      "Landmark"
                    )}
                    customOnChange={(e) => handleChange(e)}
                  />
                </Col>
                <Col xl={4} lg={4} md={6} sm={6}>
                  <InputText
                    labelName={_.get(
                      elements,
                      "branchCreationElement.pinCodeLabel",
                      "Pincode"
                    )}
                    inputType={"tel"}
                    inputName={"pincode"}
                    InputClass={"inputText"}
                    customValue={state.pincode}
                    inputPlaceholder={_.get(
                      elements,
                      "branchCreationElement.pinCodePlaceholder",
                      "Pincode*"
                    )}
                    customOnChange={(e) => handleChange(e)}
                    customRequired={true}
                  />
                </Col>
                <Col xl={4} lg={4} md={6} sm={6}>
                  <Label for="--">
                    {_.get(
                      elements,
                      "branchCreationElement.addressLineOneLabel",
                      "Address Line 1*"
                    )}
                  </Label>
                  <FormGroup>
                    <Input
                      type="textarea"
                      placeholder={_.get(
                        elements,
                        "branchCreationElement.addressLineOnePlaceholder",
                        "Address Line 1"
                      )}
                      name="addressLine1"
                      id="--"
                      className="inputText"
                      value={state.addressLine1}
                      onChange={(e) => handleChange(e)}
                      required
                    />
                  </FormGroup>
                </Col>
                <Col xl={4} lg={4} md={6} sm={6}>
                  <Label for="--">
                    {" "}
                    {_.get(
                      elements,
                      "branchCreationElement.addressLineTwoLabel",
                      "Address Line 2"
                    )}
                  </Label>
                  <FormGroup>
                    <Input
                      type="textarea"
                      placeholder={_.get(
                        elements,
                        "branchCreationElement.addressLineTwoPlaceholder",
                        "Address Line 2"
                      )}
                      name="addressLine2"
                      id="--"
                      className="inputText"
                      value={state.addressLine2}
                      onChange={(e) => handleChange(e)}
                    />
                  </FormGroup>
                </Col>
                <Col xl={4} lg={4} md={6} sm={6}>
                  <Label for="--">
                    {" "}
                    {_.get(
                      elements,
                      "branchCreationElement.addressLineThreeLabel",
                      "Address Line 3"
                    )}
                  </Label>
                  <FormGroup>
                    <Input
                      type="textarea"
                      placeholder={_.get(
                        elements,
                        "branchCreationElement.addressLineThreePlaceholder",
                        "Address Line 3"
                      )}
                      name="addressLine3"
                      id="--"
                      className="inputText"
                      value={state.addressLine3}
                      onChange={(e) => handleChange(e)}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xl={4} lg={4} md={6} sm={6}>
                  <Label for="--">
                    {" "}
                    {_.get(
                      elements,
                      "branchCreationElement.descriptionLabel",
                      "Description"
                    )}
                  </Label>
                  <FormGroup>
                    <Input
                      type="textarea"
                      placeholder={_.get(
                        elements,
                        "branchCreationElement.descriptionPlaceholder",
                        "Description"
                      )}
                      name="branchDescription"
                      id="description"
                      maxLength="2500"
                      className="inputText"
                      value={state.branchDescription}
                      onChange={(e) => handleChange(e)}
                    />
                  </FormGroup>
                </Col>
                <Col xl={4} lg={4} md={6} sm={6}>
                  <InputText
                    labelName={_.get(
                      elements,
                      "branchCreationElement.latitudeLabel",
                      "Latitude*"
                    )}
                    inputType={"number"}
                    inputName={"latitude"}
                    InputClass={"inputText"}
                    customValue={state.latitude}
                    inputPlaceholder={_.get(
                      elements,
                      "branchCreationElement.latitudePlaceholder",
                      "Latitude"
                    )}
                    customOnChange={(e) => handleCoordinateChange(e)}
                    customRequired={true}
                  />
                </Col>
                <Col xl={4} lg={4} md={6} sm={6}>
                  <InputText
                    labelName={_.get(
                      elements,
                      "branchCreationElement.longitudeLabel",
                      "Longitude*"
                    )}
                    inputType={"number"}
                    inputName={"longitude"}
                    InputClass={"inputText"}
                    customValue={state.longitude}
                    inputPlaceholder={_.get(
                      elements,
                      "branchCreationElement.longitudePlaceholder",
                      "Longitude"
                    )}
                    customOnChange={(e) => handleCoordinateChange(e)}
                    customRequired={true}
                  />
                </Col>
              </Row>

              <Row>
                <Col md="12">
                  <h3 className="title-bar secondary-title f-weight-bold my-3 pb-2 themeColor">
                    {_.get(
                      elements,
                      "branchCreationElement.subHeadingPersonalInformationElement",
                      "PERSONAL INFORMATION"
                    )}
                  </h3>
                </Col>

                {/* <Col xl={4} lg={4} md={6} sm={6}>
                  <InputText
                    labelName={_.get(
                      elements,
                      "branchCreationElement.dealerNameLabel",
                      "Dealer Name"
                    )}
                    inputType={"text"}
                    inputName={"dealerName"}
                    InputClass={"inputText"}
                    customValue={state.dealerName}
                    inputPlaceholder={_.get(
                      elements,
                      "branchCreationElement.dealerNamePlaceholder",
                      "Dealer Name"
                    )}
                    disabledType={true}
                  />
                </Col>

                <Col xl={4} lg={4} md={6} sm={6}>
                  <InputText
                    labelName={_.get(
                      elements,
                      "branchCreationElement.dealerIdLabel",
                      "Dealer Id"
                    )}
                    inputType={"tel"}
                    inputName={"dealerId"}
                    InputClass={"inputText"}
                    customValue={state.dealerId}
                    disabledType={true}
                    inputPlaceholder={_.get(
                      elements,
                      "branchCreationElement.dealerIdPlaceholder",
                      "Dealer Id"
                    )}
                  />
                </Col> */}

                <Col xl={4} lg={4} md={6} sm={6}>
                  <InputText
                    labelName={_.get(
                      elements,
                      "branchCreationElement.clubCoordinatorNameLabel",
                      "Club Coordinator Name*"
                    )}
                    inputType={"text"}
                    inputName={"storeManagerName"}
                    InputClass={"inputText"}
                    inputPlaceholder={_.get(
                      elements,
                      "branchCreationElement.clubCoordinatorPlaceholder",
                      "Club Coordinator Name"
                    )}
                    customValue={state.storeManagerName}
                    customOnChange={(e) => handleChange(e)}
                    customRequired={true}
                  />
                </Col>

                <Col xl={4} lg={4} md={6} sm={6}>
                  <InputText
                    labelName={_.get(
                      elements,
                      "branchCreationElement.branchCodeLabel",
                      "Branch Code"
                    )}
                    inputType={"tel"}
                    inputName={"branchCode"}
                    InputClass={"inputText"}
                    customValue={state.branchCode}
                    inputPlaceholder={_.get(
                      elements,
                      "branchCreationElement.branchCodePlaceholder",
                      "Branch Code"
                    )}
                    disabledType={true}
                  />
                </Col>

                <Col xl={4} lg={4} md={6} sm={6}>
                  <InputText
                    labelName={_.get(
                      elements,
                      "branchCreationElement.webUrlLabel",
                      "Website Page URL"
                    )}
                    inputType={"text"}
                    inputName={"websiteUrl"}
                    InputClass={"inputText"}
                    customValue={state.websiteUrl}
                    inputPlaceholder={_.get(
                      elements,
                      "branchCreationElement.webUrlPlaceholder",
                      "Website Page URL"
                    )}
                    customOnChange={(e) => handleChange(e)}
                  />
                </Col>

                <Col xl={4} lg={4} md={6} sm={6}>
                  <InputText
                    labelName={_.get(
                      elements,
                      "branchCreationElement.instagramUrlLabel",
                      "Instagram URL"
                    )}
                    inputType={"text"}
                    inputName={"instagramUrl"}
                    InputClass={"inputText"}
                    customValue={state.instagramUrl}
                    inputPlaceholder={_.get(
                      elements,
                      "branchCreationElement.instagramUrlPlaceholder",
                      "Instagram URL"
                    )}
                    customOnChange={(e) => handleChange(e)}
                  />
                </Col>

                <Col xl={4} lg={4} md={6} sm={6}>
                  <InputText
                    labelName={_.get(
                      elements,
                      "branchCreationElement.facebookUrlLabel",
                      "Facebook URL"
                    )}
                    inputType={"text"}
                    inputName={"facebookUrl"}
                    InputClass={"inputText"}
                    customValue={state.facebookUrl}
                    inputPlaceholder={_.get(
                      elements,
                      "branchCreationElement.facebookUrlPlaceholder",
                      "Facebook URL"
                    )}
                    customOnChange={(e) => handleChange(e)}
                  />
                </Col>

                <Col xl={4} lg={4} md={6} sm={6}>
                  <InputText
                    labelName={_.get(
                      elements,
                      "branchCreationElement.weeklyOffLabel",
                      "Weekly Off"
                    )}
                    inputType={"tel"}
                    inputName={"weeklyOff"}
                    InputClass={"inputText"}
                    customValue={state.weeklyOff}
                    inputPlaceholder={_.get(
                      elements,
                      "branchCreationElement.weeklyOffPlaceholder",
                      "Weekly Off"
                    )}
                    customOnChange={(e) => handleChange(e)}
                  />
                </Col>

                <Col xl={4} lg={4} md={6} sm={6}>
                  <Label className="inputLabel" for="--">
                    {_.get(
                      elements,
                      "branchCreationElement.businessHourLabel",
                      "Business Hours"
                    )}
                  </Label>
                  <FormGroup>
                    <Input
                      type="textarea"
                      placeholder={_.get(
                        elements,
                        "branchCreationElement.businessHourPlaceholder",
                        "Business Hours"
                      )}
                      name="businessHours"
                      id="--"
                      value={state.businessHours}
                      className="inputText"
                      onChange={(e) => handleChange(e)}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <div className="d-flex justify-content-center justify-content-lg-end position-relative ">
                <CustomButton
                  customType={"submit"}
                  name={_.get(
                    elements,
                    "branchCreationElement.submitButtonElement",
                    "Submit"
                  )}
                  customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
                />
              </div>
            </CardBody>
          </Card>
        </Form>
      </div>
    </React.Fragment>
  );
}

export default appliedBranchCreate;
